<template>
  <div id="inflowPathChart"></div>
</template>

<script>
  import c3 from 'c3'
  import d3 from 'd3'

  export default {
    name: 'inflow-path-chart',
    props: {
      chartData: {
        type: Array,
        default () {
          return []
        }
      }
    },
    mounted () {
      const config = {
        bindto: '#inflowPathChart',
        data: {
          columns: [ ...this.chartData ],
          colors: {
            total: '#eff1f8',
            active: '#9b88e9',
            new: '#ff7133'
          },
          type: 'donut'
        },
        color: {
          pattern: ['#8ebafb', '#9b88e9', '#ffd43a', '#f03e3e', '#4566c5', '#00c4ac', '#ff7133']
        },
        tooltip: {
          format: {
            value: function (value, ratio) {
              return `${value}건 (${d3.format('%')(ratio)})`
            }
          }
        }
      }

      // 컴포넌트 데이터에 차트 객체 복사 시 오류가 발생한다.
      // 대신 차트 객체를 Window 객체에 복사하여 사용한다.
      window.inflowPathChart = c3.generate(config)
    },
    beforeDestroy () {
      delete window.inflowPathChart
    }
  }
</script>

<style lang="scss">
  #inflowPathChart {
    .c3-chart-arc text {
      font-size: 12px;
      font-weight: bold;
    }

    .c3-tooltip-container {
      min-width: 156px;

      table {
        td {
          display: block;
          float: initial;
        }
        .name {
          padding: 16px 16px 8px;
        }
        .value {
          padding: 8px 16px 16px;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/admin/InflowPathChart.vue